import { Component, OnInit, ViewChild } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApplicationType } from 'src/api/models/application-type';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ApplicationService,CustomerService,CeresTagService, FireForesightService } from 'src/api/services';


@Component({
  selector: 'app-fire-foresight-onboard',
  templateUrl: './onboard.component.html',
  styleUrls: ['./onboard.component.css']
})
export class FireForesightOnBoardComponent implements OnInit {

  public applications : ApplicationType[];
  state: string;
  redirect_uri: string;
  client_id: string;
  errorMessage: string;
  
  constructor(
    private route: ActivatedRoute,
    public azureAuthService: AzureAuthService,
    public toaster: ToastrService,
    private app: ApplicationConfigService,
    private fire: FireForesightService) { }

  ngOnInit(): void {    
    
  }

 
  completeActivation(){
    this.fire.FireForesightPurchase(this.app.customerId).subscribe(s =>{

      this.toaster.success("Application Purchased Successfully", "Fire Foresight")

    }, error => {
        this.errorMessage = "It appears you do not have permission to link your Ceres Tag account to your INDICIUM Cloud account. Please contact the person in charge of your INDICIUM Dynamics account to be assigned the appropriate permissions."
        this.toaster.error("Application Purchase Failed", "Fire Foresight");
    });
    
  }
}
